import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoggingService {

  constructor() {

  }

  logMessage(msg) {
    console.log(msg);
  }
}

